import { render } from "./AstExplorer.vue?vue&type=template&id=0866e84a&scoped=true"
import script from "./AstExplorer.vue?vue&type=script&lang=js"
export * from "./AstExplorer.vue?vue&type=script&lang=js"

import "./AstExplorer.vue?vue&type=style&index=0&id=0866e84a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0866e84a"]])

export default __exports__